import { ROOM_SEPARATOR_TOKEN } from '../config';
export function roomIdsGenerator(topic, recipients) {
    if (!recipients) {
        return [topic];
    }
    return recipients.map((recipient) => `${topic}${ROOM_SEPARATOR_TOKEN}${recipient}`);
}
export function topicSubscriptionPayloadGenerator(roomIds) {
    const topicDictionary = roomIds.reduce((dictionary, roomId) => {
        const [topic, subscriber] = roomId.split(ROOM_SEPARATOR_TOKEN);
        if (!dictionary[topic]) {
            dictionary[topic] = [];
        }
        subscriber && dictionary[topic].push(subscriber);
        return dictionary;
    }, {});
    return Object.entries(topicDictionary).map(([topic, subscribers]) => ({ topics: [topic], subscribers }));
}
//# sourceMappingURL=topics.js.map